import { Grid } from "@mui/material";
import FormDatePicker from "components/FormFields/FormDatePicker";
import NonBillableToggle from "components/FormFields/NonBillableToggle";
import dayjs from "dayjs";
import React from "react";
import { DATE_FORMAT } from "static/date";
import { getFormattedDate } from "utils/date";
import BillingDiagnosisCodeInput from "./BillingDiagnosisCodeInput";

const ReportTransmissionInformationInput = ({
  fields,
  isError,
  isSubmitClicked,
  onUpdate,
  isIDTFBilling,
}) => {
  return (
    <div>
      <div className="d-flex justify-between align-items-center">
        <h2 style={{ marginTop: "16px" }}>Report Transmission Information</h2>
        <NonBillableToggle
          account={fields?.account}
          nonBillable={fields?.nonBillable}
          onChange={(event) => {
            onUpdate({ nonBillable: event.target.checked });
          }}
        />
      </div>

      <Grid container spacing={2} sx={{ marginBottom: "min(12px, 5%)" }}>
        <Grid item xs={6}>
          <FormDatePicker
            label="Report Date"
            required={true}
            value={fields?.report_date ? dayjs(fields?.report_date) : null}
            submitted={isSubmitClicked}
            hasError={isError("report_date") && isSubmitClicked}
            onChange={(date) => {
              onUpdate({ report_date: date });
            }}
            maxDate={dayjs(new Date())}
            margin="none"
            data-text="report-transmission-report-date-field"
          />
        </Grid>
        {!fields?.nonBillable && (
          <Grid item xs={6}>
            <FormDatePicker
              label="Report Billing Date"
              format={DATE_FORMAT.DEFAULT}
              value={
                fields?.report_billing_date
                  ? dayjs(fields?.report_billing_date)
                  : null
              }
              submitted={isSubmitClicked}
              onChange={(date) => {
                onUpdate({ report_billing_date: getFormattedDate(date) });
              }}
              margin="none"
              data-text="report-transmission-billing-date-field"
            />
          </Grid>
        )}
      </Grid>
      <BillingDiagnosisCodeInput
        fields={fields}
        onUpdate={onUpdate}
        isIDTFBilling={isIDTFBilling}
      />
    </div>
  );
};

export default ReportTransmissionInformationInput;
